(() => {
const existingDecoder = window.SFGVehicleDecoder;

if (
  existingDecoder?.initAllVehicleDetails &&
  existingDecoder?.normalizeVin &&
  existingDecoder?.validateVin &&
  existingDecoder?.decodeVinValue &&
  existingDecoder?.getDecodedDisplay &&
  existingDecoder?.getSavedVin &&
  existingDecoder?.saveVin &&
  existingDecoder?.clearSavedVin &&
  existingDecoder?.getCurrentVehicle &&
  existingDecoder?.setCurrentVehicle &&
  existingDecoder?.clearCurrentVehicle
) {
  existingDecoder.initAllVehicleDetails(document);
  return;
}
const API_BASE = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/';
const SAVED_VIN_KEY = 'sfg_saved_vin';
const CURRENT_VEHICLE_KEY = 'sfgCurrentVehicle';
const CURRENT_VEHICLE_VERSION = 2;
const VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
const VIN_VALUES = {
A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8,
J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9,
S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9
};
function normalizeVin(value) {
return String(value || '')
.toUpperCase()
.replace(/[^A-HJ-NPR-Z0-9]/g, '')
.slice(0, 17);
}
function vinCheckDigit(vin) {
if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) return null;
let total = 0;
for (let i = 0; i < 17; i += 1) {
const char = vin[i];
const value = /\d/.test(char) ? Number(char) : VIN_VALUES[char];
if (value == null) return null;
total += value * VIN_WEIGHTS[i];
}
const remainder = total % 11;
return remainder === 10 ? 'X' : String(remainder);
}
function isVinChecksumValid(vin) {
const expected = vinCheckDigit(vin);
return expected != null && vin[8] === expected;
}
function isVinModelYearCodeValid(vin) {
if (!vin || vin.length !== 17) return false;
return /^[A-HJ-NPR-TV-Y1-9]$/.test(vin[9]);
}
function validateVin(value) {
const vin = normalizeVin(value);
if (vin.length !== 17) {
return { valid: false, vin, message: 'Enter the full 17-digit VIN.' };
}
if (!isVinChecksumValid(vin)) {
return { valid: false, vin, message: 'VIN check digit does not match. Please check the VIN.' };
}
if (!isVinModelYearCodeValid(vin)) {
return { valid: false, vin, message: 'VIN position 10 is not a valid model-year code. Please check the VIN.' };
}
return { valid: true, vin, message: '' };
}
/*
 * Saved VIN is intentionally session-scoped.
 *
 * This keeps "Current Vehicle" and product-form VIN prefilling tied to
 * the kit/customer being worked on now instead of allowing yesterday's
 * VIN to silently reappear in a later browser session.
 */
function getSavedVin() {
try {
const vin = normalizeVin(window.sessionStorage.getItem(SAVED_VIN_KEY));
if (!vin) return '';
const validation = validateVin(vin);
if (!validation.valid) {
window.sessionStorage.removeItem(SAVED_VIN_KEY);
return '';
}
return validation.vin;
} catch (error) {
console.warn('SFG saved VIN read failed:', error);
return '';
}
}
function saveVin(value) {
const validation = validateVin(value);
if (!validation.valid) return false;
try {
window.sessionStorage.setItem(SAVED_VIN_KEY, validation.vin);
return true;
} catch (error) {
console.warn('SFG saved VIN write failed:', error);
return false;
}
}
function clearSavedVin() {
let cleared = false;

try {
window.sessionStorage.removeItem(SAVED_VIN_KEY);
cleared = true;
} catch (error) {
console.warn('SFG saved VIN clear failed:', error);
}

/*
 * Older decoder versions stored this key in localStorage.
 * Remove the legacy copy when clearing so a stale VIN can never return.
 */
try {
window.localStorage.removeItem(SAVED_VIN_KEY);
} catch (error) {
}

return cleared;
}


/*
 * =========================================================
 * CURRENT VEHICLE — SESSION KIT CONTEXT
 * =========================================================
 *
 * Only Shop Tuning by VIN explicitly sets Current Vehicle.
 * Product-page VIN edits do NOT silently replace this context.
 */
function normalizeCurrentVehicleCab(result) {
const combined = [
result?.CabType,
result?.BodyClass,
result?.Series,
result?.Series2,
result?.Trim,
result?.Trim2,
result?.Model
].map(text).join(' ');

if (/\bREGULAR CAB\b|\bSTANDARD CAB\b|\bSINGLE CAB\b/i.test(combined)) {
return 'Regular Cab';
}

if (/\bMEGA CAB\b/i.test(combined)) return 'Mega Cab';
if (/\bCREW CAB\b|\bSUPERCREW\b/i.test(combined)) return 'Crew Cab';
if (/\bEXTENDED CAB\b|\bSUPERCAB\b|\bQUAD CAB\b/i.test(combined)) return 'Extended Cab';

return '';
}

function inferCurrentVehicleEngineCode(result, manufacturer) {
const summary = engineSummary(result).toUpperCase();
const knownCodes = ['LB7','LLY','LBZ','LMM','LML','LGH','L5P','L5D','LWN','LM2','LZ0'];

if (knownCodes.includes(summary)) return summary;

const year = Number.parseInt(result?.ModelYear, 10);
const displacement = numeric(result?.DisplacementL);
const model = text(result?.Model).toUpperCase();

if (
manufacturer === 'gm' &&
isDiesel(result) &&
displacement != null
) {
if (
Math.abs(displacement - 2.8) < 0.2 &&
year >= 2016 &&
year <= 2022 &&
(/\bCOLORADO\b|\bCANYON\b/.test(model))
) {
return 'LWN';
}

if (Math.abs(displacement - 3.0) < 0.2) {
if (year >= 2020 && year <= 2022) return 'LM2';
if (year >= 2023) return 'LZ0';
}
}

return '';
}


function isGm3LDuramaxTruck(result, manufacturer = '') {
const resolvedManufacturer = manufacturer || detectManufacturer(result, '');
if (resolvedManufacturer !== 'gm') return false;

const engineCode = inferCurrentVehicleEngineCode(result, 'gm');
if (!['LM2', 'LZ0'].includes(engineCode)) return false;

const model = text(result?.Model).toUpperCase();
return /\bSILVERADO\b|\bSIERRA\b/.test(model);
}

function detectGm3LDuramaxController(result, vin) {
if (!isGm3LDuramaxTruck(result, 'gm')) return '';

const engineCode = inferCurrentVehicleEngineCode(result, 'gm');
const year = Number.parseInt(result?.ModelYear, 10);
const model = text(result?.Model).toUpperCase();
const digit5 = normalizeVin(vin).charAt(4);

// LZ0 Silverado/Sierra applications use the Global B E66 ECM.
if (engineCode === 'LZ0') return 'E66';

if (engineCode !== 'LM2' || !Number.isFinite(year)) return '';

// 2020-2021 Silverado/Sierra LM2 trucks are the non-Global-B E46 application.
if (year <= 2021) return 'E46';

// GM identifies the 2022 old-body/Limited and refreshed/New trucks by VIN digit 5.
// Silverado LTD (J21): W/Y = E46. Silverado New (J22): A/D = E66.
// Sierra Limited (J21): 8/9 = E46. Sierra New (J22): H/U = E66.
if (year === 2022) {
if (/\bSILVERADO\b/.test(model)) {
if (/[WY]/.test(digit5)) return 'E46';
if (/[AD]/.test(digit5)) return 'E66';
}

if (/\bSIERRA\b/.test(model)) {
if (/[89]/.test(digit5)) return 'E46';
if (/[HU]/.test(digit5)) return 'E66';
}

return '';
}

// Any later LM2 truck that reaches this path is Global B.
if (year >= 2023) return 'E66';

return '';
}

function inferCurrentVehicleFamily(result, manufacturer, engineCode) {
const make = text(result?.Make).toUpperCase();
const displacement = numeric(result?.DisplacementL);

if (
['RAM','DODGE','JEEP'].includes(make) &&
isDiesel(result) &&
displacement != null &&
Math.abs(displacement - 3.0) < 0.2
) {
return 'ecodiesel';
}

if (
manufacturer === 'ram' &&
isDiesel(result) &&
displacement != null &&
(
Math.abs(displacement - 5.9) < 0.2 ||
Math.abs(displacement - 6.7) < 0.2
)
) {
return 'cummins';
}

if (
manufacturer === 'ford' &&
isDiesel(result) &&
displacement != null &&
(
Math.abs(displacement - 6.0) < 0.2 ||
Math.abs(displacement - 6.4) < 0.2 ||
Math.abs(displacement - 6.7) < 0.2
)
) {
return 'powerstroke';
}

if (
manufacturer === 'gm' &&
isDiesel(result) &&
(
['LB7','LLY','LBZ','LMM','LML','LGH','L5P','L5D','LWN','LM2','LZ0'].includes(engineCode) ||
(displacement != null && Math.abs(displacement - 6.6) < 0.2)
)
) {
return 'duramax';
}

return '';
}

function buildCurrentVehicle(decoded) {
const result = decoded?.result;
const vin = normalizeVin(decoded?.vin);

if (!result || !validateVin(vin).valid) return null;

const manufacturer =
decoded?.manufacturer ||
detectManufacturer(result, vin);

const display =
decoded?.display ||
getDecodedDisplay(result, vin);

const engineCode =
inferCurrentVehicleEngineCode(
result,
manufacturer
);

const target =
decoded?.target ||
detectDecodedTarget(
result,
manufacturer
);

return {
version: CURRENT_VEHICLE_VERSION,
vin,
year: Number.parseInt(result?.ModelYear, 10) || null,
make: text(result?.Make),
model: text(result?.Model),
manufacturer,
family: inferCurrentVehicleFamily(result, manufacturer, engineCode),
engine: text(display?.engine) || engineSummary(result),
engineCode: engineCode || text(target?.key),
targetKey: text(target?.key),
displacement: numeric(result?.DisplacementL),
fuel: text(result?.FuelTypePrimary),
body: text(display?.body) || detectBody(result, manufacturer),
truckSize: text(display?.truckSize) || detectTruckSize(result, manufacturer),
rear: text(display?.rear),
drive: text(display?.drive),
transmission: text(display?.transmission),
ecmController: detectGm3LDuramaxController(result, vin),
cab: normalizeCurrentVehicleCab(result),
title: text(display?.title) || decodedVehicleLabel(result),
metaText: text(display?.metaText),
setAt: Date.now()
};
}

function getCurrentVehicle() {
try {
const raw = window.sessionStorage.getItem(CURRENT_VEHICLE_KEY);
if (!raw) return null;

const vehicle = JSON.parse(raw);

if (
!vehicle ||
vehicle.version !== CURRENT_VEHICLE_VERSION ||
!validateVin(vehicle.vin).valid
) {
window.sessionStorage.removeItem(CURRENT_VEHICLE_KEY);
return null;
}

return vehicle;
} catch (error) {
console.warn('SFG current vehicle read failed:', error);
return null;
}
}

function dispatchCurrentVehicleEvent(vehicle, source = '') {
document.dispatchEvent(
new CustomEvent(
'sfg:current-vehicle-changed',
{
detail: {
vehicle: vehicle || null,
source
}
}
)
);
}

function setCurrentVehicle(decoded, options = {}) {
const vehicle = buildCurrentVehicle(decoded);
if (!vehicle) return null;

try {
window.sessionStorage.setItem(
CURRENT_VEHICLE_KEY,
JSON.stringify(vehicle)
);
} catch (error) {
console.warn('SFG current vehicle write failed:', error);
return null;
}

saveVin(vehicle.vin);
dispatchCurrentVehicleEvent(vehicle, text(options.source));
return vehicle;
}

function clearCurrentVehicle(options = {}) {
try {
window.sessionStorage.removeItem(CURRENT_VEHICLE_KEY);
} catch (error) {
console.warn('SFG current vehicle clear failed:', error);
}

clearSavedVin();
dispatchCurrentVehicleEvent(null, text(options.source));
return true;
}
function text(value) {
return String(value || '').trim();
}
function numeric(value) {
const n = Number.parseFloat(value);
return Number.isFinite(n) ? n : null;
}
function decodeErrorCodes(result) {
return text(result?.ErrorCode)
.split(',')
.map((item) => item.trim())
.filter(Boolean);
}
function detectManufacturer(result, vin) {
const make = text(result?.Make).toUpperCase();
const manufacturer = text(result?.Manufacturer || result?.ManufacturerName).toUpperCase();
if (
['CHEVROLET', 'GMC'].includes(make) ||
manufacturer.includes('GENERAL MOTORS')
) {
return 'gm';
}
if (
['RAM', 'DODGE'].includes(make) ||
manufacturer.includes('CHRYSLER') ||
manufacturer.includes('FCA US') ||
manufacturer.includes('STELLANTIS')
) {
return 'ram';
}
if (make === 'FORD' || manufacturer.includes('FORD MOTOR')) {
return 'ford';
}
return detectManufacturerFromVin(vin);
}
function detectManufacturerFromVin(vin) {
const prefix2 = text(vin).slice(0, 2).toUpperCase();
if (['1G', '2G', '3G'].includes(prefix2)) return 'gm';
if (['1F', '2F', '3F'].includes(prefix2)) return 'ford';
if (['1C', '2C', '3C', '1D', '2D', '3D'].includes(prefix2)) return 'ram';
return 'other';
}
function detectTruckSize(result, manufacturer) {
const haystack = [result?.Model,result?.Series,result?.Series2,result?.Trim,result?.Trim2,result?.Note].map(text).join(' ');
if (manufacturer === 'ford') {
const match = haystack.match(/\bF[- ]?(250|350|450|550|600|650|750)\b/i);
return match ? `F-${match[1]}` : '';
}
if (manufacturer === 'gm' || manufacturer === 'ram') {
const match = haystack.match(/\b(?:[CK][ -]?)?(2500|3500|4500|5500|6500|7500)(?:HD)?\b/i);
return match ? match[1] : '';
}
return '';
}
function is2500Model(result, manufacturer) {
const size = detectTruckSize(result, manufacturer);
return size === '2500' || size === 'F-250';
}
function fordRearFromVin(vin, result) {
const year = Number.parseInt(result?.ModelYear, 10);
const size = detectTruckSize(result, 'ford');
if (size === 'F-250') return 'Single Rear Wheel';
if (size !== 'F-350' || year < 2016) return '';
const code = text(vin).slice(4, 7).toUpperCase();
if (/^[FWX]3[ABEF]$/.test(code)) return 'Single Rear Wheel';
if (/^[FWX]3[CDGH]$/.test(code)) return 'Dually';
return '';
}
function ramRearFromVin(vin, result) {
const year = Number.parseInt(result?.ModelYear, 10);
const size = detectTruckSize(result, 'ram');
if (size === '2500') return 'Single Rear Wheel';
if (year < 2016) return '';
if (size === '4500' || size === '5500') return 'Dually';
if (size !== '3500') return '';
const code = text(vin).slice(4, 7).toUpperCase();
if (/^R(?:[23][A-Z0-9]|[CD][AC]|[89][AC])$/.test(code)) return 'Single Rear Wheel';
if (/^R(?:[PR][A-Z0-9]|[ST][ABC])$/.test(code)) return 'Dually';
return '';
}
function detectRearWheel(result, vin, manufacturer) {
const haystack = [result?.Series,result?.Series2,result?.Trim,result?.Trim2,result?.Note,result?.BodyClass,result?.Model,result?.VehicleType].map(text).join(' ');
if (/\bdual rear wheel(?:s)?\b|\bdually\b|\bDRW\b/i.test(haystack)) return 'Dually';
if (/\bsingle rear wheel(?:s)?\b|\bSRW\b/i.test(haystack)) return 'Single Rear Wheel';
if (manufacturer === 'ford') return fordRearFromVin(vin, result);
if (manufacturer === 'ram') return ramRearFromVin(vin, result);
return '';
}
function detectDrive(result) {
const drive = text(result?.DriveType);
if (/\b4WD\b|4[- ]Wheel Drive|\b4x4\b/i.test(drive)) return '4WD';
if (/\b2WD\b|\b4x2\b|Rear[- ]Wheel Drive|\bRWD\b/i.test(drive)) return '2WD';
return '';
}

// Non-HD vehicles use the decoded drivetrain only as VIN confirmation.
// Keep FWD/RWD/AWD/4WD distinct here; the existing HD truck workflow above
// intentionally continues to normalize rear-drive trucks to 2WD.
function detectNonHdDrive(result) {
const drive = text(result?.DriveType);
if (/\bAWD\b|All[- ]Wheel Drive/i.test(drive)) return 'AWD';
if (/\b4WD\b|4[- ]Wheel Drive|\b4x4\b/i.test(drive)) return '4WD';
if (/\bFWD\b|Front[- ]Wheel Drive/i.test(drive)) return 'FWD';
if (/\bRWD\b|Rear[- ]Wheel Drive/i.test(drive)) return 'RWD';
if (/\b2WD\b|\b4x2\b/i.test(drive)) return '2WD';
return '';
}
function detectGm4wdControl(result, truckSize) {
if (detectDrive(result) !== '4WD') return '';
const year = Number.parseInt(result?.ModelYear, 10);
if (!['2500','3500'].includes(truckSize) || !year) return '';
const make = text(result?.Make).toUpperCase();
const trim = [result?.Trim,result?.Trim2,result?.Series,result?.Series2].map(text).join(' ').toUpperCase();
if (year >= 2020) return 'Electronic';
if (/\bWT\b|WORK TRUCK/.test(trim)) return 'Floor Shift';
if (year >= 2011 && year <= 2019) {
if (/\bBASE\b/.test(trim)) return 'Floor Shift';
if (make === 'CHEVROLET' && /\bLT\b|\bLTZ\b|HIGH COUNTRY/.test(trim)) return 'Electronic';
if (make === 'GMC' && /\bSLE\b|\bSLT\b|\bDENALI\b/.test(trim)) return 'Electronic';
}
if (year >= 2001 && year <= 2010) {
if (/\bBASE\b/.test(trim)) return 'Floor Shift';
if (year >= 2007 && /\bLTZ\b|\bSLT\b|\bDENALI\b/.test(trim)) return 'Electronic';
}
return '';
}
function detectBody(result, manufacturer) {
const model = text(result?.Model);
const bodyClass = text(result?.BodyClass);
const series = text(result?.Series);
const vehicleType = text(result?.VehicleType);
const combined = `${model} ${bodyClass} ${series} ${vehicleType}`;
if (/chassis cab|cab chassis|incomplete|cutaway|cut-away/i.test(combined)) {
return 'Cab & Chassis';
}
if (/\bpickup\b/i.test(bodyClass)) return 'Pickup';
if (
manufacturer === 'gm' &&
(/\bExpress\b/i.test(model) || /\bSavana\b/i.test(model) || /\bvan\b/i.test(bodyClass))
) {
return 'Van';
}
return '';
}
function isDiesel(result) {
return /diesel/i.test(text(result?.FuelTypePrimary));
}
function isLghApplication(result, manufacturer) {
if (manufacturer !== 'gm') return false;
const model = text(result?.Model);
const isExpressSavana = /\bExpress\b|\bSavana\b/i.test(model);
if (!isExpressSavana) return false;
if (/\bLGH\b/i.test(text(result?.EngineModel))) return true;
const year = Number.parseInt(result?.ModelYear, 10);
const displacement = numeric(result?.DisplacementL);
return (
year >= 2011 &&
year <= 2016 &&
displacement != null &&
Math.abs(displacement - 6.6) < 0.2 &&
isDiesel(result)
);
}
function explicitRamTransmission(result) {
const combined = [
result?.TransmissionStyle,
result?.OtherEngineInfo,
result?.EngineModel,
result?.Series,
result?.Trim
].map(text).join(' ');
if (/\b48RE\b/i.test(combined)) return '48RE';
if (/\b68RFE\b/i.test(combined)) return '68RFE';
if (/\bNV[- ]?5600\b/i.test(combined)) return 'NV5600';
if (/\bG[- ]?56\b/i.test(combined)) return 'G56';
if (/\bAISIN\b|\bAS68RC\b|\bAS69RC\b|\b6GR6\b/i.test(combined)) return 'AISIN';
if (/TORQUEFLITE\s*HD|8[- ]?SPEED/i.test(combined)) return 'TorqueFlite HD 8-Speed';
return '';
}
function ramTransmissionRules(result, body) {
const exact = explicitRamTransmission(result);
if (exact) {
return {
exact,
options: [exact],
note: 'Transmission identified from decoded vehicle data.'
};
}
const year = Number.parseInt(result?.ModelYear, 10);
const displacement = numeric(result?.DisplacementL);
const model = text(result?.Model).toUpperCase();
const style = text(result?.TransmissionStyle).toLowerCase();
const isAutomatic = style.includes('automatic');
const isManual = style.includes('manual');
const is59 = displacement != null && Math.abs(displacement - 5.9) < 0.2;
const is67 = displacement != null && Math.abs(displacement - 6.7) < 0.2;
const is2500 = /\b2500\b/.test(model);
const is3500 = /\b3500\b/.test(model);
const is4500or5500 = /\b(?:4500|5500)\b/.test(model);
let options = ['48RE', '68RFE', 'NV5600', 'G56', 'AISIN', 'TorqueFlite HD 8-Speed'];
let note = 'Select the transmission installed in the truck.';
if (is59 && year >= 2003 && year <= 2004) {
options = ['48RE', 'NV5600'];
note = '2003–2004 5.9L Cummins applications use the applicable 48RE or NV5600 selection here.';
if (isAutomatic) return { exact: '48RE', options: ['48RE'], note };
if (isManual) return { exact: 'NV5600', options: ['NV5600'], note };
} else if (is59 && year === 2005) {
options = ['48RE', 'NV5600', 'G56'];
note = '2005 5.9L Cummins trucks may use 48RE, NV5600, or G56; NV5600 and G56 overlapped during the model year.';
if (isAutomatic) return { exact: '48RE', options: ['48RE'], note };
} else if (is59 && year >= 2006 && year <= 2007) {
options = ['48RE', 'G56'];
note = '2006–2007 5.9L Cummins applications use the applicable 48RE or G56 selection here.';
if (isAutomatic) return { exact: '48RE', options: ['48RE'], note };
if (isManual) return { exact: 'G56', options: ['G56'], note };
}
if (is67 && year >= 2007 && year <= 2012) {
if (body === 'Cab & Chassis') {
options = ['G56', 'AISIN'];
note = '2007.5–2012 Cummins chassis-cab applications use G56 or AISIN here.';
if (isAutomatic) return { exact: 'AISIN', options: ['AISIN'], note };
if (isManual) return { exact: 'G56', options: ['G56'], note };
} else if (body === 'Pickup') {
options = ['68RFE', 'G56'];
note = '2007.5–2012 Cummins pickups use 68RFE or G56 here.';
if (isAutomatic) return { exact: '68RFE', options: ['68RFE'], note };
if (isManual) return { exact: 'G56', options: ['G56'], note };
} else {
options = ['68RFE', 'G56', 'AISIN'];
}
}
if (is67 && year >= 2013 && year <= 2018) {
if (body === 'Cab & Chassis' || is4500or5500) {
options = ['G56', 'AISIN'];
note = '2013–2018 Cummins chassis-cab applications use G56 or AISIN here.';
if (isAutomatic) return { exact: 'AISIN', options: ['AISIN'], note };
if (isManual) return { exact: 'G56', options: ['G56'], note };
} else if (is2500) {
options = ['68RFE', 'G56'];
note = '2013–2018 Ram 2500 Cummins pickups use 68RFE or G56 here.';
if (isAutomatic) return { exact: '68RFE', options: ['68RFE'], note };
if (isManual) return { exact: 'G56', options: ['G56'], note };
} else if (is3500) {
options = ['68RFE', 'G56', 'AISIN'];
note = '2013–2018 Ram 3500 Cummins pickups can require 68RFE, G56, or AISIN selection.';
if (isManual) return { exact: 'G56', options: ['G56'], note };
if (isAutomatic) {
options = ['68RFE', 'AISIN'];
note = 'Automatic 2013–2018 Ram 3500 Cummins pickups use 68RFE or AISIN depending on engine output.';
}
}
}
if (is67 && year >= 2019 && year <= 2024) {
if (body === 'Cab & Chassis' || is4500or5500) {
options = ['AISIN'];
note = '2019–2024 Cummins chassis-cab applications use AISIN here.';
return { exact: 'AISIN', options: ['AISIN'], note };
}
if (is2500) {
options = ['68RFE'];
note = '2019–2024 Ram 2500 Cummins pickups use 68RFE here.';
return { exact: '68RFE', options: ['68RFE'], note };
}
if (is3500) {
options = ['68RFE', 'AISIN'];
note = '2019–2024 Ram 3500 Cummins pickups may use 68RFE or AISIN depending on engine output.';
}
}
if (is67 && year >= 2025) {
options = ['TorqueFlite HD 8-Speed'];
note = '2025+ Ram Heavy Duty Cummins applications use the TorqueFlite HD 8-speed here.';
return { exact: 'TorqueFlite HD 8-Speed', options, note };
}
return { exact: '', options, note };
}
function engineSummary(result) {
const displacement = numeric(result?.DisplacementL);
const fuel = text(result?.FuelTypePrimary);
const make = text(result?.Make).toUpperCase();
const engineText = [result?.EngineModel, result?.OtherEngineInfo].map(text).join(' ');
const gmCodes = ['LB7','LLY','LBZ','LMM','LML','LGH','L5P','L5D','LWN','LM2','LZ0'];
for (const code of gmCodes) {
if (new RegExp(`\\b${code}\\b`, 'i').test(engineText)) return code;
}
if (/diesel/i.test(fuel)) {
if (make === 'RAM' || make === 'DODGE') {
if (displacement != null && Math.abs(displacement - 6.7) < 0.2) return '6.7L Cummins';
if (displacement != null && Math.abs(displacement - 5.9) < 0.2) return '5.9L Cummins';
}
if (make === 'FORD' && displacement != null) return `${displacement.toFixed(1)}L Power Stroke`;
if (displacement != null) return `${displacement.toFixed(1)}L Diesel`;
}
if (displacement != null && displacement > 0) return `${displacement.toFixed(1)}L`;
return text(result?.EngineModel);
}

function detectListingTarget(title) {
const value = text(title).toUpperCase();
const hasCode = (code) => new RegExp(`\\b${code}\\b`).test(value);

// Some Duramax products intentionally cover two engine codes on one listing.
// Treat both codes as valid instead of letting the first code in the title win.
if (hasCode('LB7') && hasCode('LLY')) {
return {
family: 'gm',
key: 'LB7/LLY',
allowedKeys: ['LB7', 'LLY'],
label: 'LB7/LLY Duramax'
};
}
if (hasCode('LBZ') && hasCode('LMM')) {
return {
family: 'gm',
key: 'LBZ/LMM',
allowedKeys: ['LBZ', 'LMM'],
label: 'LBZ/LMM Duramax'
};
}

for (const code of ['LB7','LLY','LBZ','LMM','LML','L5P']) {
if (hasCode(code)) {
return { family: 'gm', key: code, allowedKeys: [code], label: `${code} Duramax` };
}
}

const ramLabels = {
CMB: 'CMB (2006–2007 5.9L Cummins)',
CMC: 'CMC (2007–2009 6.7L Cummins)',
CMD: 'CMD (2010–2012 6.7L Cummins)',
CME: 'CME (2013–2018 6.7L Cummins)',
CMF: 'CMF (2019+ 6.7L Cummins)'
};
for (const code of ['CMB','CMC','CMD','CME','CMF']) {
if (hasCode(code)) {
return { family: 'ram', key: code, allowedKeys: [code], label: ramLabels[code] };
}
}

const has67 = /\b6\.7L?\b/.test(value);
const hasF650 = /\bF[- ]?650\b/.test(value);
const hasF750 = /\bF[- ]?750\b/.test(value);
const isFordMediumDutyListing = hasF650 && hasF750;
const yearRange = (start, end) => new RegExp(
`\\b${start}\\s*[-–—]\\s*${end}\\b`
).test(value);

// F-650/F-750 products have their own fitment path even though they share the
// underlying 6.7L calibration families with the broader Ford year collections.
if (isFordMediumDutyListing) {
if (yearRange(2016, 2019) || yearRange(2015, 2019)) {
return {
family: 'ford',
key: 'FORD-6.7-2015-2019',
allowedKeys: ['FORD-6.7-2015-2019'],
label: '2016–2019 F-650/F-750 6.7L Power Stroke',
mediumDuty: true
};
}
if (yearRange(2020, 2022)) {
return {
family: 'ford',
key: 'FORD-6.7-2020-2022',
allowedKeys: ['FORD-6.7-2020-2022'],
label: '2020–2022 F-650/F-750 6.7L Power Stroke',
mediumDuty: true
};
}
}

if (has67) {
if (yearRange(2011, 2014)) {
return { family: 'ford', key: 'FORD-6.7-2011-2014', allowedKeys: ['FORD-6.7-2011-2014'], label: '2011–2014 6.7L Power Stroke', mediumDuty: false };
}
if (yearRange(2015, 2019)) {
return { family: 'ford', key: 'FORD-6.7-2015-2019', allowedKeys: ['FORD-6.7-2015-2019'], label: '2015–2019 6.7L Power Stroke', mediumDuty: false };
}
if (yearRange(2020, 2022)) {
return { family: 'ford', key: 'FORD-6.7-2020-2022', allowedKeys: ['FORD-6.7-2020-2022'], label: '2020–2022 6.7L Power Stroke', mediumDuty: false };
}
if (yearRange(2023, 2026)) {
return { family: 'ford', key: 'FORD-6.7-2023-2026', allowedKeys: ['FORD-6.7-2023-2026'], label: '2023–2026 6.7L Power Stroke', mediumDuty: false };
}
}

if (/\b6\.4L?\b/.test(value)) {
return { family: 'ford', key: 'FORD-6.4', allowedKeys: ['FORD-6.4'], label: '6.4L Power Stroke' };
}
// Match a standalone 6.0L/6L engine reference without treating values such
// as 1.6L as a Ford 6.0L listing.
if (/(?:^|[^0-9.])6(?:\.0)?L?\b/.test(value)) {
return { family: 'ford', key: 'FORD-6.0', allowedKeys: ['FORD-6.0'], label: '6.0L Power Stroke' };
}

return null;
}

// Generic Non-HD fitment validation. This intentionally infers only constraints
// that are explicit in the product title: a model-year range, model name(s),
// displacement, and selected engine codes. Missing VIN data never causes a
// rejection; only a clear contradiction does.
const GENERIC_FITMENT_ENGINE_CODES = [
'LB7','LLY','LBZ','LMM','LML','LGH','L5P','L5D','LWN','LM2','LZ0'
];

const GENERIC_FITMENT_STOPWORDS = new Set([
'TUNE','TUNES','TUNING','SOTF','SINGLE','SWITCHABLE','SWITCH','STAGE','CUSTOM',
'PACK','PACKS','FILE','FILES','PACKAGE','ECU','ECM','TCM','PCM','HP','EFI','EFILIVE',
'EZ','EZLYNK','TZ','TUNEZILLA','LYNK','DIESEL','CUMMINS','DURAMAX',
'POWERSTROKE','POWER','STROKE','ECODIESEL','TDI','CDI','BLUETEC'
]);

function normalizeFitmentToken(value) {
return text(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function getGenericYearRange(title) {
const value = text(title);
const rangeMatch = value.match(/\b((?:19|20)\d{2})\s*[-–—]\s*((?:19|20)\d{2})\b/);
if (rangeMatch) {
const start = Number.parseInt(rangeMatch[1], 10);
const end = Number.parseInt(rangeMatch[2], 10);
if (!Number.isFinite(start) || !Number.isFinite(end)) return null;
return { start: Math.min(start, end), end: Math.max(start, end), matchText: rangeMatch[0] };
}

const openEndedMatch = value.match(/\b((?:19|20)\d{2})\s*\+/);
if (openEndedMatch) {
const start = Number.parseInt(openEndedMatch[1], 10);
if (!Number.isFinite(start)) return null;
return { start, end: 9999, matchText: openEndedMatch[0] };
}

return null;
}

function getGenericDisplacements(title) {
const matches = [...text(title).matchAll(/\b(\d+(?:\.\d+)?)\s*L\b/gi)];
return [...new Set(matches
.map((match) => Number.parseFloat(match[1]))
.filter((value) => Number.isFinite(value) && value > 0 && value < 20)
)];
}

function getGenericEngineCodes(title) {
const value = text(title).toUpperCase();
return GENERIC_FITMENT_ENGINE_CODES.filter((code) =>
new RegExp(`\\b${code}\\b`, 'i').test(value)
);
}

function cleanGenericModelExpression(title, yearRange, engineCodes) {
let value = text(title);

// Remove storefront/platform suffixes such as "-TZ", "-HP", "-EFI", and "-EZ".
value = value.replace(/\s+-\s*(?:TZ|HP|EFI|EZ)\b.*$/i, ' ');

// Remove the explicit year range and any parentheses surrounding it.
if (yearRange?.matchText) {
const escaped = yearRange.matchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
value = value.replace(new RegExp(`\\(?\\s*${escaped}\\s*\\)?`, 'i'), ' ');
}

// Remove displacements; they are validated separately.
value = value.replace(/\b\d+(?:\.\d+)?\s*L\b/gi, ' ');

// Remove engine codes that are validated separately.
for (const code of engineCodes || []) {
value = value.replace(new RegExp(`\\b${code}\\b`, 'gi'), ' ');
}

// Remove known tuning/engine descriptors without maintaining a model whitelist.
value = value
.split(/(\/|\bor\b|&)/i)
.map((part) => {
if (/^(\/|or|&)$/i.test(part.trim())) return part;
return part
.split(/\s+/)
.filter(Boolean)
.filter((token) => !GENERIC_FITMENT_STOPWORDS.has(normalizeFitmentToken(token)))
.join(' ');
})
.join(' ')
.replace(/\s+/g, ' ')
.trim();

return value;
}

function detectGenericListingTarget(title) {
const value = text(title);
const looksLikeTuningProduct =
/\bTUNE\b|\bTUNING\b|\bSOTF\b|\s-\s*(?:TZ|HP|EFI|EZ)\b/i.test(value);
if (!looksLikeTuningProduct) return null;

const yearRange = getGenericYearRange(value);
if (!yearRange) return null;

const displacements = getGenericDisplacements(title);
const engineCodes = getGenericEngineCodes(title);
const modelExpression = cleanGenericModelExpression(title, yearRange, engineCodes);
const modelOptions = modelExpression
.split(/\s*(?:\/|\bor\b|&)\s*/i)
.map((option) => option.trim())
.filter(Boolean)
.map((option) => ({
label: option,
tokens: option
.split(/\s+/)
.map(normalizeFitmentToken)
.filter(Boolean)
.filter((token) => !GENERIC_FITMENT_STOPWORDS.has(token))
}))
.filter((option) => option.tokens.length);

// Engine-family listings do not always include a vehicle model name.
// Example: "LM2/LZ0 3L Single Tune (2020-2025) -HP".
// When explicit engine codes are present, year/displacement/engine validation
// is sufficient; keep modelOptions empty so model matching is simply skipped.
if (!modelOptions.length && !engineCodes.length) return null;

const cleanLabel = text(title)
.replace(/\s+-\s*(?:TZ|HP|EFI|EZ)\b.*$/i, '')
.replace(/\s+/g, ' ')
.trim();

return {
yearStart: yearRange.start,
yearEnd: yearRange.end,
modelOptions,
displacements,
engineCodes,
label: cleanLabel || text(title)
};
}

function genericIdentityFields(result) {
return [
result?.Make,
result?.Manufacturer,
result?.ManufacturerName,
result?.Model,
result?.Series,
result?.Series2,
result?.Trim,
result?.Trim2,
result?.BodyClass
]
.map(normalizeFitmentToken)
.filter(Boolean);
}

function genericTokenVariants(token) {
const aliases = {
CHEVY: ['CHEVY', 'CHEVROLET'],
CHEVROLET: ['CHEVROLET', 'CHEVY'],
MERCEDES: ['MERCEDES', 'MERCEDESBENZ'],
BENZ: ['BENZ', 'MERCEDESBENZ'],
VW: ['VW', 'VOLKSWAGEN'],
VOLKSWAGEN: ['VOLKSWAGEN', 'VW']
};
return aliases[token] || [token];
}

function genericModelOptionMatches(result, option) {
const fields = genericIdentityFields(result);
if (!fields.length || !option?.tokens?.length) return null;

return option.tokens.every((token) => {
const variants = genericTokenVariants(token);
return variants.some((variant) =>
fields.some((field) => field.includes(variant))
);
});
}

function genericModelMatches(result, target) {
if (!target?.modelOptions?.length) return null;
const results = target.modelOptions.map((option) => genericModelOptionMatches(result, option));
if (results.some((value) => value === true)) return true;
if (results.every((value) => value == null)) return null;
return false;
}

function genericDisplacementMatches(result, target) {
if (!target?.displacements?.length) return null;
const decoded = numeric(result?.DisplacementL);
if (decoded == null) return null;
return target.displacements.some((expected) => Math.abs(decoded - expected) <= 0.15);
}

function genericEngineCodeMatches(result, target) {
if (!target?.engineCodes?.length) return null;
const decoded = engineSummary(result).toUpperCase();
if (!GENERIC_FITMENT_ENGINE_CODES.includes(decoded)) return null;
return target.engineCodes.includes(decoded);
}

function decodedVehicleLabel(result) {
return [text(result?.ModelYear), text(result?.Make), text(result?.Model)]
.filter(Boolean)
.join(' ') || 'the decoded vehicle';
}

function evaluateGenericListingCompatibility(result, target) {
if (!result || !target) return '';

const year = Number.parseInt(result?.ModelYear, 10);
if (
Number.isFinite(year) &&
(year < target.yearStart || year > target.yearEnd)
) {
return `Vehicle mismatch: this VIN decodes as ${decodedVehicleLabel(result)}. This product is for ${target.label}.`;
}

const modelMatch = genericModelMatches(result, target);
if (modelMatch === false) {
return `Vehicle mismatch: this VIN decodes as ${decodedVehicleLabel(result)}. This product is for ${target.label}.`;
}

const displacementMatch = genericDisplacementMatches(result, target);
if (displacementMatch === false) {
const decodedDisplacement = numeric(result?.DisplacementL);
const decodedEngine = decodedDisplacement != null ? `${decodedDisplacement.toFixed(1)}L` : engineSummary(result);
return `Vehicle mismatch: this VIN decodes as ${decodedVehicleLabel(result)}${decodedEngine ? ` with ${decodedEngine}` : ''}. This product is for ${target.label}.`;
}

const engineCodeMatch = genericEngineCodeMatches(result, target);
if (engineCodeMatch === false) {
return `Vehicle mismatch: this VIN decodes as ${decodedVehicleLabel(result)} with ${engineSummary(result)}. This product is for ${target.label}.`;
}

return '';
}

function isHdConfigurationListingTitle(title) {
const listing = detectListingTarget(title);
if (listing) {
const keys = Array.isArray(listing.allowedKeys) && listing.allowedKeys.length
? listing.allowedKeys
: [listing.key];
const gm3LOnly = keys.length > 0 && keys.every((key) => ['LM2', 'LZ0'].includes(key));
if (!gm3LOnly) return true;
}
const value = text(title).toUpperCase();
return (
/\bLGH\b/.test(value) ||
/\bGMT?515\b/.test(value) ||
/\bKODIAK\b|\bTOPKICK\b/.test(value) ||
/\bF[- ]?(?:250|350|450|550|600|650|750)\b/.test(value) ||
/\b(?:2500|3500|4500|5500|6500|7500)(?:HD)?\b/.test(value)
);
}

function detectDecodedTarget(result, manufacturer) {
const year = Number.parseInt(result?.ModelYear, 10);
const displacement = numeric(result?.DisplacementL);

if (manufacturer === 'gm') {
const summary = engineSummary(result).toUpperCase();
for (const code of ['LB7','LLY','LBZ','LMM','LML','L5P','LM2','LZ0']) {
if (summary === code) {
return { family: 'gm', key: code, label: `${code} Duramax` };
}
}
return null;
}

if (manufacturer === 'ram') {
if (displacement != null && Math.abs(displacement - 5.9) < 0.2 && year >= 2006 && year <= 2007) {
return { family: 'ram', key: 'CMB', label: 'CMB (2006–2007 5.9L Cummins)' };
}
if (displacement != null && Math.abs(displacement - 6.7) < 0.2) {
if (year >= 2007 && year <= 2009) return { family: 'ram', key: 'CMC', label: 'CMC (2007–2009 6.7L Cummins)' };
if (year >= 2010 && year <= 2012) return { family: 'ram', key: 'CMD', label: 'CMD (2010–2012 6.7L Cummins)' };
if (year >= 2013 && year <= 2018) return { family: 'ram', key: 'CME', label: 'CME (2013–2018 6.7L Cummins)' };
if (year >= 2019) return { family: 'ram', key: 'CMF', label: 'CMF (2019+ 6.7L Cummins)' };
}
return null;
}

if (manufacturer === 'ford' && displacement != null) {
if (Math.abs(displacement - 6.0) < 0.2) {
return { family: 'ford', key: 'FORD-6.0', label: '6.0L Power Stroke' };
}
if (Math.abs(displacement - 6.4) < 0.2) {
return { family: 'ford', key: 'FORD-6.4', label: '6.4L Power Stroke' };
}
if (Math.abs(displacement - 6.7) < 0.2) {
if (year >= 2011 && year <= 2014) return { family: 'ford', key: 'FORD-6.7-2011-2014', label: '2011–2014 6.7L Power Stroke' };
if (year >= 2015 && year <= 2019) return { family: 'ford', key: 'FORD-6.7-2015-2019', label: '2015–2019 6.7L Power Stroke' };
if (year >= 2020 && year <= 2022) return { family: 'ford', key: 'FORD-6.7-2020-2022', label: '2020–2022 6.7L Power Stroke' };
if (year >= 2023 && year <= 2026) return { family: 'ford', key: 'FORD-6.7-2023-2026', label: '2023–2026 6.7L Power Stroke' };
}
}
return null;
}

// Truck-specific questions are required only for applications where those
// details are meaningful. Preserve every existing HD/special-duty path while
// allowing passenger/light-duty applications from the same manufacturers to
// use the decoder without SRW/DRW, chassis, fuel-tank, or HD transmission prompts.
function isHdConfigurationApplication(result, manufacturer) {
if (!result) return false;

// LM2/LZ0 Silverado/Sierra trucks need a decoded target for Shop Tuning by VIN,
// but they must remain on the light-duty 3.0L configuration path rather than
// inheriting the HD Duramax SRW/DRW, chassis, fuel-tank, and transmission prompts.
if (isGm3LDuramaxTruck(result, manufacturer)) return false;

if (detectDecodedTarget(result, manufacturer)) return true;

const truckSize = detectTruckSize(result, manufacturer);
if (truckSize) return true;

if (manufacturer === 'gm') {
if (isLghApplication(result, 'gm')) return true;
const model = getNormalizedModel(result);
if (
model.includes('GM515') ||
model.includes('GMT515') ||
model === 'C4' ||
model === 'C5' ||
model.includes('KODIAK') ||
model.includes('TOPKICK')
) {
return true;
}
}

return false;
}

function isSotfProductTitle(title) {
return /\bSOTF\b/i.test(text(title));
}

function detectTuningPlatformFromTitle(title) {
const value = text(title).toUpperCase();

// Platform labels are expected as standalone title tokens such as -HP, -EFI, -EZ, or -TZ.
// Requiring token boundaries prevents values such as 500HP from being treated as the HP platform.
if (/(?:^|[\s\-–—])HP(?:$|[\s(])/i.test(value)) return 'HP';
if (/(?:^|[\s\-–—])EFI(?:$|[\s(])/i.test(value)) return 'EFI';
if (/(?:^|[\s\-–—])EZ(?:$|[\s(])/i.test(value)) return 'EZ';
if (/(?:^|[\s\-–—])TZ(?:$|[\s(])/i.test(value)) return 'TZ';
return '';
}

function platformUses2022To2024RamEcmWorkflow(title) {
// 2022-2024 RAM CMF ECMs no longer require an unlock.
// This legacy ECM status/source/unlock workflow is disabled for all platforms.
return false;
}

function getNormalizedModel(result) {
return text(result?.Model)
.toUpperCase()
.replace(/[^A-Z0-9]/g, '');
}

function isFordMediumDuty(result) {
const model = getNormalizedModel(result);
const truckSize = detectTruckSize(result, 'ford');
return (
model.startsWith('F650') ||
model.startsWith('F750') ||
truckSize === 'F-650' ||
truckSize === 'F-750'
);
}

function getSotfAvailability(result, options = {}) {
if (!result) return null;

const year = Number.parseInt(result?.ModelYear, 10);
const manufacturer = options.manufacturer || detectManufacturer(result, options.vin || '');
const decodedTarget = detectDecodedTarget(result, manufacturer);
const key = options.key || decodedTarget?.key || '';
const body = text(options.body) || detectBody(result, manufacturer);
const chassisCab = body === 'Cab & Chassis';
const model = getNormalizedModel(result);

const isGM515 =
model.includes('GM515') ||
model.includes('GMT515');

const isKodiakTopKick =
model === 'C4' ||
model === 'C5' ||
model.includes('KODIAK') ||
model.includes('TOPKICK');

const fordMediumDuty = isFordMediumDuty(result);

const isLegacyDuramax =
key === 'LB7' ||
key === 'LLY' ||
key === 'LBZ' ||
key === 'LMM';

const isRamCummins =
key === 'CMB' ||
key === 'CMC' ||
key === 'CMD' ||
key === 'CME' ||
key === 'CMF';

// 2019-2023 GM / GMT515 medium-duty applications support single tunes, but not SOTF.
if (isGM515 && year >= 2019 && year <= 2023) {
return 'unavailable';
}

// 2001-2010 Duramax cab & chassis and Kodiak / TopKick / C4 / C5 applications.
if (
isLegacyDuramax &&
year >= 2001 &&
year <= 2010 &&
(chassisCab || isKodiakTopKick)
) {
return 'unavailable';
}

// 2016-2022 F-650 / F-750 6.7L Power Stroke applications.
if (
fordMediumDuty &&
year >= 2016 &&
year <= 2022 &&
(
key === 'FORD-6.7-2015-2019' ||
key === 'FORD-6.7-2020-2022'
)
) {
return 'unavailable';
}

// 2022-2024 Cummins cab & chassis applications do not support SOTF.
if (
chassisCab &&
key === 'CMF' &&
year >= 2022 &&
year <= 2024
) {
return 'unavailable';
}

// LML cab & chassis applications can use SOTF only with a single fuel tank.
if (
chassisCab &&
key === 'LML' &&
year >= 2011 &&
year <= 2016
) {
return 'single-tank-only';
}

// 2017-2023 L5P cab & chassis applications, except GM515, require a single fuel tank for SOTF.
if (
chassisCab &&
key === 'L5P' &&
year >= 2017 &&
year <= 2023
) {
return 'single-tank-only';
}

// RAM Cummins cab & chassis applications where SOTF is otherwise supported require a single fuel tank.
// 2022-2024 CMF cab & chassis trucks are handled above as fully unavailable.
if (
chassisCab &&
isRamCummins &&
!(key === 'CMF' && year >= 2022 && year <= 2024)
) {
return 'single-tank-only';
}

return null;
}

function getDecodedDisplay(result, vin) {
const manufacturer = detectManufacturer(result, vin);
const hdApplication = isHdConfigurationApplication(result, manufacturer);
const truckSize = hdApplication ? detectTruckSize(result, manufacturer) : '';
const rear = hdApplication
? (is2500Model(result, manufacturer)
? 'Single Rear Wheel'
: detectRearWheel(result, vin, manufacturer))
: '';
const drive = hdApplication ? detectDrive(result) : detectNonHdDrive(result);
const body = hdApplication ? detectBody(result, manufacturer) : '';
const engine = engineSummary(result);
const extras = [];
let resolvedBody = body;
let fourWdControl = '';
let transmission = '';

if (!hdApplication) {
if (drive) extras.push(drive);
} else if (manufacturer === 'gm') {
const lghVan = isLghApplication(result, 'gm');
resolvedBody = lghVan && body === 'Van' ? 'LGH Van' : body;
fourWdControl = drive === '4WD' ? detectGm4wdControl(result, truckSize) : '';
if (lghVan) transmission = '6L90';
if (drive) extras.push(drive);
if (rear) extras.push(rear === 'Dually' ? 'DRW' : 'SRW');
if (resolvedBody) extras.push(resolvedBody);
if (truckSize) extras.push(truckSize);
if (fourWdControl) extras.push(`${fourWdControl} 4WD`);
if (transmission) extras.push(transmission);
} else if (manufacturer === 'ram') {
const rules = ramTransmissionRules(result, body);
transmission = rules.exact || '';
if (drive) extras.push(drive);
if (rear) extras.push(rear === 'Dually' ? 'DRW' : 'SRW');
if (body) extras.push(body);
if (truckSize) extras.push(truckSize);
if (transmission) extras.push(transmission);
} else if (manufacturer === 'ford') {
if (drive) extras.push(drive);
if (rear) extras.push(rear === 'Dually' ? 'DRW' : 'SRW');
if (body) extras.push(body);
if (truckSize) extras.push(truckSize);
}

const year = text(result?.ModelYear);
const make = text(result?.Make);
const model = text(result?.Model);
const title = [year, make, model].filter(Boolean).join(' ') || 'VIN decoded';
const meta = [engine, ...extras].filter(Boolean);

return {
vin: normalizeVin(vin),
title,
meta,
metaText: meta.join(' · '),
engine,
manufacturer,
hdApplication,
truckSize,
rear,
drive,
body: resolvedBody,
fourWdControl,
transmission,
target: detectDecodedTarget(result, manufacturer)
};
}

async function fetchDecodedVin(vin, signal) {
const response = await fetch(
`${API_BASE}${encodeURIComponent(vin)}?format=json`,
{
method: 'GET',
headers: { Accept: 'application/json' },
signal
}
);
if (!response.ok) throw new Error(`VIN lookup returned HTTP ${response.status}`);
const payload = await response.json();
const result = payload?.Results?.[0];
if (!result) throw new Error('VIN lookup returned no decoded vehicle.');
const codes = decodeErrorCodes(result);
const fatalVinError = ['1', '2', '3', '5', '6', '11', '400']
.some((code) => codes.includes(code));
if (fatalVinError) {
const message = text(result.ErrorText) || 'The VIN could not be validated exactly. Please check the VIN.';
const error = new Error(message);
error.sfgVinInvalid = true;
throw error;
}
const hasIdentity = text(result.ModelYear) && text(result.Make) && text(result.Model);
if (!hasIdentity) throw new Error('VIN lookup did not return year, make, and model.');
return result;
}

async function decodeVinValue(value, options = {}) {
const validation = validateVin(value);
if (!validation.valid) throw new Error(validation.message);
const requestedTimeout = Number(options.timeoutMs);
const timeoutMs = Number.isFinite(requestedTimeout)
? Math.min(Math.max(requestedTimeout, 1000), 15000)
: 6000;
const controller = new AbortController();
let timedOut = false;
const timeoutId = window.setTimeout(() => {
timedOut = true;
controller.abort();
}, timeoutMs);
try {
const result = await fetchDecodedVin(validation.vin, controller.signal);
const manufacturer = detectManufacturer(result, validation.vin);
return {
vin: validation.vin,
result,
manufacturer,
target: detectDecodedTarget(result, manufacturer),
display: getDecodedDisplay(result, validation.vin)
};
} catch (error) {
if (error?.name === 'AbortError' && timedOut) {
throw new Error('VIN lookup timed out. Please try again.');
}
throw error;
} finally {
window.clearTimeout(timeoutId);
}
}

function dispatchDecodedEvent(vin, result, context = 'vehicle-details', root = null) {
const manufacturer = detectManufacturer(result, vin);
document.dispatchEvent(new CustomEvent('sfg:vin-decoded', {
detail: {
vin: normalizeVin(vin),
result,
manufacturer,
target: detectDecodedTarget(result, manufacturer),
display: getDecodedDisplay(result, vin),
context,
root
}
}));
}

function initVehicleDetails(root) {
if (!root || root.dataset.sfgVehicleInitialized === '1') return;
const formId = root.dataset.formId;
const form = document.getElementById(formId);
const productTitle = text(root.dataset.sfgProductTitle);
const listingTarget = detectListingTarget(productTitle);
const genericListingTarget = listingTarget ? null : detectGenericListingTarget(productTitle);
const isSotfListing = isSotfProductTitle(productTitle);
const vinInput = root.querySelector('[data-sfg-vin]');
const vinStatus = root.querySelector('[data-sfg-vin-status]');
const decodedBox = root.querySelector('[data-sfg-decoded]');
const decodedTitle = root.querySelector('[data-sfg-decoded-title]');
const decodedMeta = root.querySelector('[data-sfg-decoded-meta]');
const editButton = root.querySelector('[data-sfg-edit-details]');
const conditionalHost = root.querySelector('[data-sfg-conditional-host]');
const conditionalTemplate = root.querySelector('[data-sfg-conditional-template]');
const tireInput = root.querySelector('[data-sfg-tire-size]');
const modificationsInput = root.querySelector('[data-sfg-modifications]');

const requiredElements = {
vinInput,
vinStatus,
decodedBox,
decodedTitle,
decodedMeta,
editButton,
conditionalHost,
conditionalTemplate,
tireInput,
modificationsInput
};
const missingElement = Object.entries(requiredElements).find(([, element]) => !element);
if (missingElement) {
throw new Error(`Missing required Vehicle Details element: ${missingElement[0]}`);
}

const state = {
manufacturer: '',
result: null,
hdApplication: false,
body: '',
truckSize: '',
rear: '',
rearLocked: false,
drive: '',
transmission: '',
manualOverride: false,
decodeStatus: 'empty',
controller: null,
timer: null,
requestToken: 0,
compatibilityMismatch: ''
};
function property(name) {
return root.querySelector(`[data-sfg-property="${name}"]`);
}
function setProperty(name, value) {
const input = property(name);
if (input) input.value = value || '';
}
function getProperty(name) {
return text(property(name)?.value);
}
function dispatchVehicleDetailsUpdated() {
document.dispatchEvent(new CustomEvent('sfg:vehicle-details-updated', {
detail: {
root,
formId,
vin: normalizeVin(vinInput?.value),
engineCode: state.result ? inferCurrentVehicleEngineCode(state.result, state.manufacturer) : '',
ecmController: getProperty('ecm-controller'),
cruiseControl: getProperty('cruise-control')
}
}));
}
function setStatus(message, status = '') {
vinStatus.textContent = message || '';
if (status) vinStatus.dataset.state = status;
else delete vinStatus.dataset.state;
}

function evaluateCompatibility(result) {
state.compatibilityMismatch = '';
if (!result) return '';

const decodedTarget = detectDecodedTarget(result, state.manufacturer);

if (listingTarget) {
if (listingTarget.family !== state.manufacturer && ['gm','ram','ford'].includes(state.manufacturer)) {
const decodedLabel = engineSummary(result) || `${text(result.ModelYear)} ${text(result.Make)} ${text(result.Model)}`;
state.compatibilityMismatch =
`Vehicle mismatch: this VIN decodes as ${decodedLabel}. This product is for ${listingTarget.label}.`;
return state.compatibilityMismatch;
}

if (decodedTarget) {
const allowedKeys = Array.isArray(listingTarget.allowedKeys) && listingTarget.allowedKeys.length
? listingTarget.allowedKeys
: [listingTarget.key];

if (!allowedKeys.includes(decodedTarget.key)) {
state.compatibilityMismatch =
`Vehicle mismatch: this VIN decodes as ${decodedTarget.label}. This product is for ${listingTarget.label}.`;
return state.compatibilityMismatch;
}

}
}

if (!listingTarget && genericListingTarget) {
const genericMismatch = evaluateGenericListingCompatibility(result, genericListingTarget);
if (genericMismatch) {
state.compatibilityMismatch = genericMismatch;
return state.compatibilityMismatch;
}
}

// EZ Lynk does not support the Global B E66 3.0L Duramax application.
// This blocks refreshed 2022 LM2 E66 trucks and LZ0 E66 trucks while leaving
// E46 LM2 trucks and all non-EZ platforms unaffected.
if (
detectTuningPlatformFromTitle(productTitle) === 'EZ' &&
detectGm3LDuramaxController(result, vinInput.value) === 'E66'
) {
state.compatibilityMismatch =
'Vehicle mismatch: this truck uses an E66 ECM, which is not supported by EZ Lynk. Please select a supported tuning platform.';
return state.compatibilityMismatch;
}

if (isSotfListing) {
const body = getProperty('body') || state.body || detectBody(result, state.manufacturer);
const fuelTank = getProperty('fuel');
const targetKey = decodedTarget?.key || listingTarget?.key || '';
const sotfAvailability = getSotfAvailability(result, {
manufacturer: state.manufacturer,
key: targetKey,
body,
vin: vinInput.value
});

if (sotfAvailability === 'unavailable') {
state.compatibilityMismatch =
'Vehicle mismatch: Switch-on-the-Fly (SOTF) tuning is not available for this vehicle.';
return state.compatibilityMismatch;
}

if (sotfAvailability === 'single-tank-only' && fuelTank === 'Dual Fuel Tank') {
state.compatibilityMismatch =
'Vehicle mismatch: Switch-on-the-Fly (SOTF) tuning is not available on dual fuel tank trucks. Select the single-tune product for this vehicle.';
return state.compatibilityMismatch;
}
}

// 2016-2022 F-650/F-750 trucks share the broader 6.7L calibration family,
// but must use a dedicated medium-duty product listing. SOTF incompatibility
// is checked first so a medium-duty SOTF attempt gets the more useful SOTF error.
if (
listingTarget?.family === 'ford' &&
decodedTarget &&
['FORD-6.7-2015-2019', 'FORD-6.7-2020-2022'].includes(decodedTarget.key)
) {
const decodedMediumDuty = isFordMediumDuty(result);
const listingMediumDuty = listingTarget.mediumDuty === true;

if (decodedMediumDuty && !listingMediumDuty) {
state.compatibilityMismatch =
'Vehicle mismatch: this VIN decodes as an F-650/F-750 medium-duty truck. Select the F-650/F-750 listing for this vehicle.';
return state.compatibilityMismatch;
}

if (!decodedMediumDuty && listingMediumDuty) {
state.compatibilityMismatch =
'Vehicle mismatch: this F-650/F-750 product is only for F-650/F-750 medium-duty trucks.';
return state.compatibilityMismatch;
}
}

return '';
}

function refreshCompatibilityStatus(successMessage = 'VIN verified ✓') {
if (!state.result) return '';
const compatibilityError = evaluateCompatibility(state.result);
vinInput.setCustomValidity(compatibilityError);
if (compatibilityError) {
setStatus(compatibilityError, 'error');
} else if (state.decodeStatus === 'success') {
setStatus(successMessage);
}
return compatibilityError;
}

function clearRadioGroup(groupName) {
root.querySelectorAll(`[data-sfg-choice="${groupName}"]`).forEach((input) => {
input.checked = false;
});
}
function checkRadio(groupName, value) {
if (!value) return false;
const input = Array.from(root.querySelectorAll(`[data-sfg-choice="${groupName}"]`))
.find((candidate) => candidate.value === value && !candidate.disabled);
if (!input) return false;
input.checked = true;
return true;
}
function selected(groupName) {
return text(root.querySelector(`[data-sfg-choice="${groupName}"]:checked`)?.value);
}
function setElementHidden(element, shouldHide) {
if (!element) return;
element.hidden = Boolean(shouldHide);
if (shouldHide) {
element.style.setProperty('display', 'none', 'important');
} else {
element.style.removeProperty('display');
}
}
function ensureConditionalFields() {
if (!conditionalHost || !conditionalTemplate) return;
if (conditionalHost.childElementCount) return;
conditionalHost.appendChild(conditionalTemplate.content.cloneNode(true));
}
function clearConditionalFields() {
if (!conditionalHost) return;
conditionalHost.replaceChildren();
}
function setGroupVisible(groupName, visible, required = false) {
const group = root.querySelector(`[data-sfg-group="${groupName}"]`);
if (!group) return;
setElementHidden(group, !visible);
const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
radios.forEach((radio) => {
radio.disabled = !visible;
radio.required = false;
});
if (visible && required) {
const firstEnabled = radios.find((radio) => !radio.disabled);
if (firstEnabled) firstEnabled.required = true;
}
}
function is2022To2024RamEcmApplication() {
if (state.manufacturer !== 'ram') return false;
if (!platformUses2022To2024RamEcmWorkflow(productTitle)) return false;

if (state.result) {
const year = Number.parseInt(state.result?.ModelYear, 10);
const target = detectDecodedTarget(state.result, 'ram');
return target?.key === 'CMF' && year >= 2022 && year <= 2024;
}

// If the VIN API is unavailable, still ask the ECM questions only when the
// product itself clearly identifies the 2022-2024 CMF application and its
// tuning platform is one that uses this unlock workflow.
return (
listingTarget?.family === 'ram' &&
listingTarget?.key === 'CMF' &&
/\b2022\s*[-–—]\s*2024\b/.test(productTitle)
);
}

function selectedRamUnlockInput() {
return root.querySelector('[data-sfg-choice="ram-ecm-unlock"]:checked');
}

function findMatchingAddonBlock() {
const selectors = [
'[data-sfg-hp-addons]',
'[data-sfg-efi-addons]'
];

for (const selector of selectors) {
const block = Array.from(document.querySelectorAll(selector))
.find((item) => item.dataset.formId === formId);
if (block) return block;
}

return null;
}

function syncRamUnlockAddon() {
const addonBlock = findMatchingAddonBlock();
if (!addonBlock) return;

let group = addonBlock.querySelector('[data-sfg-ram-unlock-addon]');

if (!group) {
group = document.createElement('fieldset');
group.hidden = true;
group.style.setProperty('display', 'none', 'important');
group.dataset.sfgAddonGroup = '1';
group.dataset.sfgRamUnlockAddon = '1';

const name = `sfg-ram-unlock-addon-${root.dataset.sfgSectionId || formId}`;

const yes = document.createElement('input');
yes.type = 'radio';
yes.name = name;
yes.value = 'yes';
yes.dataset.sfgAddonChoice = '1';
yes.dataset.addonQuantity = '1';

const no = document.createElement('input');
no.type = 'radio';
no.name = name;
no.value = 'no';
no.dataset.sfgAddonChoice = '1';
no.checked = true;

group.append(yes, no);
addonBlock.appendChild(group);
}

const yes = group.querySelector('input[data-sfg-addon-choice][value="yes"]');
const no = group.querySelector('input[data-sfg-addon-choice][value="no"]');
if (!yes || !no) return;

const ecmStatus = selected('ram-ecm-status') || getProperty('ecm-status');
const unlockInput = selectedRamUnlockInput();
const shouldInclude =
is2022To2024RamEcmApplication() &&
ecmStatus === 'ECM Still Locked' &&
unlockInput;

if (shouldInclude) {
const variantId = text(unlockInput.dataset.sfgUnlockVariant);
const unitPrice = text(unlockInput.dataset.sfgUnlockPrice);

yes.dataset.addonVariantId = variantId;
yes.dataset.addonUnitPrice = unitPrice;
yes.dataset.addonQuantity = '1';
yes.checked = true;
no.checked = false;
} else {
delete yes.dataset.addonVariantId;
delete yes.dataset.addonUnitPrice;
yes.checked = false;
no.checked = true;
}

// Reuse the existing HP Tuners / EFI Live add-on listeners.
// Their configured-total and batch-cart code already reads
// data-sfg-addon-group + data-sfg-addon-choice.
(no.checked ? no : yes).dispatchEvent(
new Event('change', { bubbles: true })
);
}

function updateRamEcmGroups() {
const applicable = is2022To2024RamEcmApplication();
setGroupVisible('ram-ecm-status', applicable, applicable);

if (!applicable) {
setGroupVisible('ram-ecm-source', false);
setGroupVisible('ram-ecm-unlock', false);
setProperty('ecm-status', '');
setProperty('ecm-source', '');
setProperty('ecm-unlock-choice', '');
syncRamUnlockAddon();
return;
}

const ecmStatus = selected('ram-ecm-status') || getProperty('ecm-status');
const needsSource = ecmStatus === '2019–2021 Unlocked ECM Installed';
const needsUnlock = ecmStatus === 'ECM Still Locked';

setGroupVisible('ram-ecm-source', needsSource, needsSource);
setGroupVisible('ram-ecm-unlock', needsUnlock, needsUnlock);

if (!needsSource) {
clearRadioGroup('ram-ecm-source');
setProperty('ecm-source', '');
}

if (!needsUnlock) {
clearRadioGroup('ram-ecm-unlock');
setProperty('ecm-unlock-choice', '');
setProperty('cruise-control', '');
setProperty('ecm-controller', '');
}

syncRamUnlockAddon();
}

function showBranch(name) {
root.querySelectorAll('[data-sfg-branch]').forEach((branch) => {
setElementHidden(branch, branch.dataset.sfgBranch !== name);
});
}
function resetBranchGroups() {
[
'gm-drive', 'gm-4wd-control', 'gm-body', 'gm-fuel', 'gm-cruise',
'ram-body', 'ram-fuel', 'ram-ecm-status', 'ram-ecm-source', 'ram-ecm-unlock', 'ram-trans',
'ford-drive', 'ford-4wd-control'
].forEach((name) => setGroupVisible(name, false));
}
function resetPropertiesForNewVin() {
setProperty('vehicle', '');
setProperty('rear', '');
setProperty('drive', '');
setProperty('4wd-control', '');
setProperty('body', '');
setProperty('truck-size', '');
setProperty('fuel', '');
setProperty('transmission', '');
setProperty('ecm-status', '');
setProperty('ecm-source', '');
setProperty('ecm-unlock-choice', '');
}
function showDecoded(result, extras = []) {
const year = text(result?.ModelYear);
const make = text(result?.Make);
const model = text(result?.Model);
const title = [year, make, model].filter(Boolean).join(' ');
const meta = [engineSummary(result), ...extras].filter(Boolean);
decodedTitle.textContent = title || 'VIN decoded';
decodedMeta.textContent = meta.join(' · ');
setElementHidden(decodedBox, false);
setElementHidden(editButton, false);
if (title) setProperty('vehicle', title);
}
function hideDecoded() {
setElementHidden(decodedBox, true);
decodedTitle.textContent = '';
decodedMeta.textContent = '';
setElementHidden(editButton, true);
}
function setRamTransmissionChoices(rules, forceManual = false) {
const allowed = new Set(rules.options || ['48RE', '68RFE', 'NV5600', 'G56', 'AISIN', 'TorqueFlite HD 8-Speed']);
const group = root.querySelector('[data-sfg-group="ram-trans"]');
const labels = Array.from(root.querySelectorAll('[data-sfg-ram-trans-option]'));
const note = root.querySelector('[data-sfg-ram-trans-note]');
if (note) note.textContent = rules.note || '';
if (rules.exact && !forceManual) {
state.transmission = rules.exact;
setProperty('transmission', rules.exact);
setGroupVisible('ram-trans', false);
return;
}
if (group) setElementHidden(group, false);
labels.forEach((label) => {
const value = label.dataset.sfgRamTransOption;
const input = label.querySelector('input');
const show = allowed.has(value);
setElementHidden(label, !show);
input.disabled = !show;
input.required = false;
if (!show && input.checked) input.checked = false;
});
const firstEnabled = labels
.map((label) => label.querySelector('input'))
.find((input) => input && !input.disabled);
if (firstEnabled) firstEnabled.required = true;
if (rules.exact) {
checkRadio('ram-trans', rules.exact);
setProperty('transmission', rules.exact);
} else {
const current = getProperty('transmission');
if (!allowed.has(current)) setProperty('transmission', '');
}
}
function applyRearWheel(value, forceManual = false) {
state.rear = value || '';
if (value) setProperty('rear', value);
if (value && !forceManual) {
setGroupVisible('rear', false);
} else {
setGroupVisible('rear', true, true);
if (value) checkRadio('rear', value);
}
}
function applyGm(result, forceManual = false) {
showBranch('gm');
const drive = detectDrive(result);
const body = detectBody(result, 'gm');
const truckSize = state.truckSize || detectTruckSize(result, 'gm');
const lghVan = isLghApplication(result, 'gm');
const gm4wdControl = drive === '4WD' ? detectGm4wdControl(result, truckSize) : '';
state.drive = drive;
state.body = body;
if (drive) setProperty('drive', drive);
const resolvedBody = lghVan && body === 'Van' ? 'LGH Van' : body;
if (resolvedBody) setProperty('body', resolvedBody);
if (drive && !forceManual) {
setGroupVisible('gm-drive', false);
} else {
setGroupVisible('gm-drive', true, true);
if (drive) checkRadio('gm-drive', drive);
}
const effectiveDrive = drive || selected('gm-drive');
const needs4wd = effectiveDrive === '4WD';
if (!needs4wd) {
setGroupVisible('gm-4wd-control', false);
setProperty('4wd-control', '');
} else if (gm4wdControl && !forceManual) {
setProperty('4wd-control', gm4wdControl);
setGroupVisible('gm-4wd-control', false);
} else {
setGroupVisible('gm-4wd-control', true, true);
if (gm4wdControl) {
setProperty('4wd-control', gm4wdControl);
checkRadio('gm-4wd-control', gm4wdControl);
}
}
if (body === 'Van' && !forceManual) {
setGroupVisible('gm-body', false);
setGroupVisible('gm-fuel', lghVan, lghVan);
if (!lghVan) setProperty('fuel', '');
} else if (body && !forceManual) {
setGroupVisible('gm-body', false);
const needsFuel = body === 'Cab & Chassis';
setGroupVisible('gm-fuel', needsFuel, needsFuel);
if (!needsFuel) setProperty('fuel', '');
} else {
setGroupVisible('gm-body', true, true);
const manualBody = lghVan && body === 'Van' ? 'LGH Van' : body;
if (manualBody) checkRadio('gm-body', manualBody);
const effectiveBody = selected('gm-body') || manualBody;
const needsFuel = effectiveBody === 'Cab & Chassis' || effectiveBody === 'LGH Van';
setGroupVisible('gm-fuel', needsFuel, needsFuel);
if (!needsFuel) setProperty('fuel', '');
}
if (lghVan) {
setProperty('transmission', '6L90');
state.transmission = '6L90';
} else {
setProperty('transmission', '');
state.transmission = '';
}
const extras = [];
if (drive) extras.push(drive);
if (state.rear) extras.push(state.rear === 'Dually' ? 'DRW' : 'SRW');
if (resolvedBody) extras.push(resolvedBody);
if (truckSize) extras.push(truckSize);
if (gm4wdControl) extras.push(`${gm4wdControl} 4WD`);
if (lghVan) extras.push('6L90');
showDecoded(result, extras);
}
function applyRam(result, forceManual = false) {
showBranch('ram');
const body = detectBody(result, 'ram');
const truckSize = state.truckSize || detectTruckSize(result, 'ram');
const drive = detectDrive(result);
state.body = body;
state.drive = drive;
if (body) setProperty('body', body);
if (drive) setProperty('drive', drive);
if (body && !forceManual) {
setGroupVisible('ram-body', false);
setGroupVisible('ram-fuel', body === 'Cab & Chassis', body === 'Cab & Chassis');
} else {
setGroupVisible('ram-body', true, true);
if (body) checkRadio('ram-body', body);
const effectiveBody = body || selected('ram-body');
setGroupVisible('ram-fuel', effectiveBody === 'Cab & Chassis', effectiveBody === 'Cab & Chassis');
}
const rules = ramTransmissionRules(result, body || selected('ram-body'));
setRamTransmissionChoices(rules, forceManual);
updateRamEcmGroups();
const extras = [];
if (drive) extras.push(drive);
if (state.rear) extras.push(state.rear === 'Dually' ? 'DRW' : 'SRW');
if (body) extras.push(body);
if (truckSize) extras.push(truckSize);
if (rules.exact) extras.push(rules.exact);
showDecoded(result, extras);
}
function applyFord(result, forceManual = false) {
showBranch('ford');
const drive = detectDrive(result);
const body = detectBody(result, 'ford');
const truckSize = state.truckSize || detectTruckSize(result, 'ford');
state.drive = drive;
state.body = body;
if (drive) setProperty('drive', drive);
if (body) setProperty('body', body);
if (drive && !forceManual) {
setGroupVisible('ford-drive', false);
} else {
setGroupVisible('ford-drive', true, true);
if (drive) checkRadio('ford-drive', drive);
}
setGroupVisible('ford-4wd-control', false);
clearRadioGroup('ford-4wd-control');
setProperty('4wd-control', '');
const extras = [];
if (drive) extras.push(drive);
if (state.rear) extras.push(state.rear === 'Dually' ? 'DRW' : 'SRW');
if (body) extras.push(body);
if (truckSize) extras.push(truckSize);
showDecoded(result, extras);
}

function applyGm3LDuramaxTruck(result) {
showBranch('gm');

// LM2/LZ0 1500s are not part of the legacy HD question set.
setGroupVisible('rear', false);
clearRadioGroup('rear');
setGroupVisible('gm-drive', false);
setGroupVisible('gm-4wd-control', false);
setGroupVisible('gm-body', false);
setGroupVisible('gm-fuel', false);

const drive = detectNonHdDrive(result);
const controller = detectGm3LDuramaxController(result, vinInput.value);
const cruise = selected('gm-cruise');

state.drive = drive;
state.body = '';
state.truckSize = '';
state.rear = '';
state.rearLocked = false;
state.transmission = '';

setProperty('rear', '');
setProperty('drive', drive);
setProperty('4wd-control', '');
setProperty('body', '');
setProperty('truck-size', '');
setProperty('fuel', '');
setProperty('transmission', '');
setProperty('ecm-controller', controller);
if (cruise) setProperty('cruise-control', cruise);

setGroupVisible('gm-cruise', true, true);

const extras = [];
if (drive) extras.push(drive);
if (controller) extras.push(controller);
showDecoded(result, extras);

// There are no manual HD fields to reopen on this application; the cruise
// selection remains visible directly below the decoded vehicle details.
setElementHidden(editButton, true);
dispatchVehicleDetailsUpdated();
}

function applyOther(result) {
showBranch('');
resetBranchGroups();
setGroupVisible('rear', false);
clearRadioGroup('rear');

const drive = detectNonHdDrive(result);
state.drive = drive;
state.body = '';
state.truckSize = '';
state.rear = '';
state.rearLocked = false;
state.transmission = '';

setProperty('rear', '');
setProperty('body', '');
setProperty('truck-size', '');
setProperty('fuel', '');
setProperty('4wd-control', '');
setProperty('transmission', '');
setProperty('drive', drive);
setProperty('cruise-control', '');
setProperty('ecm-controller', '');

showDecoded(result, drive ? [drive] : []);
// Non-HD details are informational only; there are no manual truck fields to edit.
setElementHidden(editButton, true);
dispatchVehicleDetailsUpdated();
}
function applyDecodedResult(result, forceManual = false) {
state.result = result;
state.manufacturer = detectManufacturer(result, vinInput.value);
state.hdApplication = isHdConfigurationApplication(result, state.manufacturer);
state.manualOverride = forceManual;
resetBranchGroups();

if (!state.hdApplication) {
if (isGm3LDuramaxTruck(result, state.manufacturer)) {
applyGm3LDuramaxTruck(result);
} else {
applyOther(result);
}
return;
}

// Existing HD logic below is intentionally unchanged.
state.body = detectBody(result, state.manufacturer);
state.truckSize = detectTruckSize(result, state.manufacturer);
setProperty('truck-size', state.truckSize);
state.rearLocked = is2500Model(result, state.manufacturer);
state.rear = state.rearLocked
? 'Single Rear Wheel'
: detectRearWheel(result, vinInput.value, state.manufacturer);
applyRearWheel(
state.rear,
forceManual && !state.rearLocked
);
if (state.manufacturer === 'gm') {
applyGm(result, forceManual);
} else if (state.manufacturer === 'ram') {
applyRam(result, forceManual);
} else if (state.manufacturer === 'ford') {
applyFord(result, forceManual);
} else {
applyOther(result);
}
}
function applyApiFailureFallback(vin) {
state.result = null;
state.manufacturer = detectManufacturerFromVin(vin);
// With no decoded vehicle data, only invoke the HD fallback when the product
// itself is one of the recognized HD tuning listings. Non-HD listings remain
// VIN-only rather than guessing truck configuration from a manufacturer prefix.
state.hdApplication = isHdConfigurationListingTitle(productTitle);
state.manualOverride = true;
state.body = '';
state.truckSize = '';
state.rear = '';
state.rearLocked = false;
state.drive = '';
state.transmission = '';
state.compatibilityMismatch = '';
hideDecoded();
resetBranchGroups();

if (!state.hdApplication) {
setGroupVisible('rear', false);
setProperty('rear', '');
setProperty('drive', '');
setProperty('4wd-control', '');
setProperty('body', '');
setProperty('truck-size', '');
setProperty('fuel', '');
setProperty('transmission', '');
showBranch('');
return;
}

applyRearWheel('', true);
if (state.manufacturer === 'gm') {
showBranch('gm');
setGroupVisible('gm-drive', true, true);
setGroupVisible('gm-body', true, true);
} else if (state.manufacturer === 'ram') {
showBranch('ram');
setGroupVisible('ram-body', true, true);
setRamTransmissionChoices({
exact: '',
options: ['48RE', '68RFE', 'NV5600', 'G56', 'AISIN', 'TorqueFlite HD 8-Speed'],
note: 'VIN lookup was unavailable. Select the installed transmission.'
}, true);
updateRamEcmGroups();
} else if (state.manufacturer === 'ford') {
showBranch('ford');
setGroupVisible('ford-drive', true, true);
} else {
showBranch('');
}
}
function updateDependentGroups() {
if (!state.hdApplication) return;
if (state.manufacturer === 'gm') {
const drive = selected('gm-drive') || state.drive;
if (selected('gm-drive')) setProperty('drive', selected('gm-drive'));
const needs4wd = drive === '4WD';
const auto4wdControl = state.result ? detectGm4wdControl(state.result, state.truckSize) : '';
if (!needs4wd) {
setGroupVisible('gm-4wd-control', false);
setProperty('4wd-control', '');
} else if (auto4wdControl && !state.manualOverride) {
setProperty('4wd-control', auto4wdControl);
setGroupVisible('gm-4wd-control', false);
} else {
setGroupVisible('gm-4wd-control', true, true);
/* In manual-edit mode, use the decoded value only as the initial
   selection. Once the customer chooses a control type, do not
   overwrite that choice on the ensuing change event. */
const manual4wdChoice = selected('gm-4wd-control');
if (!manual4wdChoice && auto4wdControl) {
setProperty('4wd-control', auto4wdControl);
checkRadio('gm-4wd-control', auto4wdControl);
}
}
const body = selected('gm-body') || getProperty('body') || state.body;
if (selected('gm-body')) setProperty('body', selected('gm-body'));
const needsFuel = body === 'Cab & Chassis' || body === 'LGH Van';
setGroupVisible('gm-fuel', needsFuel, needsFuel);
if (!needsFuel) setProperty('fuel', '');
const decodedLgh = state.result ? isLghApplication(state.result, 'gm') : false;
if (body === 'LGH Van' || decodedLgh) {
setProperty('transmission', '6L90');
state.transmission = '6L90';
} else if (getProperty('transmission') === '6L90') {
setProperty('transmission', '');
state.transmission = '';
}
}
if (state.manufacturer === 'ram') {
const body = selected('ram-body') || state.body;
if (selected('ram-body')) setProperty('body', selected('ram-body'));
const needsFuel = body === 'Cab & Chassis';
setGroupVisible('ram-fuel', needsFuel, needsFuel);
if (!needsFuel) setProperty('fuel', '');
if (state.result) {
const rules = ramTransmissionRules(state.result, body);
setRamTransmissionChoices(rules, state.manualOverride);
}
updateRamEcmGroups();
}
if (state.manufacturer === 'ford') {
const drive = selected('ford-drive') || state.drive;
if (selected('ford-drive')) setProperty('drive', selected('ford-drive'));
setGroupVisible('ford-4wd-control', false);
clearRadioGroup('ford-4wd-control');
setProperty('4wd-control', '');
}
}
function syncSelectionsToProperties() {
const rear = selected('rear');
if (rear) setProperty('rear', rear);
const gmDrive = selected('gm-drive');
const fordDrive = selected('ford-drive');
if (gmDrive) setProperty('drive', gmDrive);
if (fordDrive) setProperty('drive', fordDrive);
const gm4wd = selected('gm-4wd-control');
if (gm4wd) setProperty('4wd-control', gm4wd);
if (state.manufacturer === 'ford') setProperty('4wd-control', '');
const gmBody = selected('gm-body');
const ramBody = selected('ram-body');
if (gmBody) setProperty('body', gmBody);
if (ramBody) setProperty('body', ramBody);
const gmFuel = selected('gm-fuel');
const ramFuel = selected('ram-fuel');
if (gmFuel) setProperty('fuel', gmFuel);
if (ramFuel) setProperty('fuel', ramFuel);
const ramTrans = selected('ram-trans');
if (ramTrans) setProperty('transmission', ramTrans);
const ramEcmStatus = selected('ram-ecm-status');
if (ramEcmStatus) setProperty('ecm-status', ramEcmStatus);
const ramEcmSource = selected('ram-ecm-source');
if (ramEcmSource) setProperty('ecm-source', ramEcmSource);
const ramEcmUnlock = selected('ram-ecm-unlock');
if (ramEcmUnlock) setProperty('ecm-unlock-choice', ramEcmUnlock);
const gmCruise = selected('gm-cruise');
if (gmCruise) setProperty('cruise-control', gmCruise);
}
function firstMissingRequirement() {
const vin = normalizeVin(vinInput.value);
if (vin.length !== 17) return 'Enter the full 17-digit VIN.';
if (!isVinChecksumValid(vin)) return 'The VIN check digit does not match. Please check the VIN.';
if (!isVinModelYearCodeValid(vin)) return 'VIN position 10 is not a valid model-year code. Please check the VIN.';
if (state.decodeStatus === 'loading') return 'VIN lookup is still in progress.';
if (state.result) evaluateCompatibility(state.result);
if (state.compatibilityMismatch) return state.compatibilityMismatch;
if (state.result && isGm3LDuramaxTruck(state.result, state.manufacturer) && !getProperty('cruise-control')) {
return 'Select Standard Cruise Control or Adaptive Cruise Control (Radar).';
}
const modifications = text(modificationsInput?.value);
if (!modifications) {
return 'List all relevant modifications. Enter Stock only if the vehicle is factory stock.';
}
if (state.hdApplication && !getProperty('rear')) return 'Select Single Rear Wheel or Dually.';
if (state.hdApplication && state.manufacturer === 'gm') {
if (!getProperty('drive')) return 'Select 2WD or 4WD.';
if (getProperty('drive') === '4WD' && !getProperty('4wd-control')) {
return 'Select Electronic or Floor Shift 4WD control.';
}
if (getProperty('body') !== 'Van' && !getProperty('body')) {
return 'Select Pickup or Cab & Chassis.';
}
if (['Cab & Chassis','LGH Van'].includes(getProperty('body')) && !getProperty('fuel')) {
return 'Select Single Fuel Tank or Dual Fuel Tank.';
}
}
if (state.hdApplication && state.manufacturer === 'ram') {
if (!getProperty('body')) return 'Select Pickup or Cab & Chassis.';
if (getProperty('body') === 'Cab & Chassis' && !getProperty('fuel')) {
return 'Select Single Fuel Tank or Dual Fuel Tank.';
}
if (is2022To2024RamEcmApplication()) {
const ecmStatus = getProperty('ecm-status');
if (!ecmStatus) return 'Select the current ECM Status.';
if (ecmStatus === '2019–2021 Unlocked ECM Installed' && !getProperty('ecm-source')) {
return 'Select the 2019–2021 ECM Source.';
}
if (ecmStatus === 'ECM Still Locked') {
const unlockInput = selectedRamUnlockInput();
if (!getProperty('ecm-unlock-choice') || !unlockInput) {
return 'Select Mail-In ECM Unlock or New Unlocked ECM.';
}
if (!text(unlockInput.dataset.sfgUnlockVariant)) {
return 'The selected ECM unlock is currently unavailable.';
}
if (!findMatchingAddonBlock()) {
return 'The ECM unlock could not be attached to this product configuration. Please contact support.';
}
}
}
if (!getProperty('transmission')) return 'Select the transmission.';
}
if (state.hdApplication && state.manufacturer === 'ford') {
if (!getProperty('drive')) return 'Select 2WD or 4WD.';
}
return '';
}
function focusMissingRequirement(message) {
let target = null;
if (message.includes('dual fuel tank')) target = root.querySelector('[data-sfg-group$="fuel"] input:not(:disabled)');
else if (message.includes('Vehicle mismatch') || message.includes('17-digit') || message.includes('check digit')) target = vinInput;
else if (message.includes('relevant modifications') || message.includes('factory stock')) target = modificationsInput;
else if (message.includes('Single Rear Wheel')) target = root.querySelector('[data-sfg-group="rear"] input:not(:disabled)');
else if (message.includes('2WD')) target = root.querySelector('[data-sfg-group$="drive"] input:not(:disabled)');
else if (message.includes('4WD control')) target = root.querySelector('[data-sfg-group$="4wd-control"] input:not(:disabled)');
else if (message.includes('Pickup')) target = root.querySelector('[data-sfg-group$="body"] input:not(:disabled)');
else if (message.includes('Fuel Tank')) target = root.querySelector('[data-sfg-group$="fuel"] input:not(:disabled)');
else if (message.includes('Cruise Control')) target = root.querySelector('[data-sfg-group="gm-cruise"] input:not(:disabled)');
else if (message.includes('ECM Status')) target = root.querySelector('[data-sfg-group="ram-ecm-status"] input:not(:disabled)');
else if (message.includes('ECM Source')) target = root.querySelector('[data-sfg-group="ram-ecm-source"] input:not(:disabled)');
else if (
message.includes('Mail-In ECM Unlock') ||
message.includes('selected ECM unlock') ||
message.includes('ECM unlock is currently unavailable')
) {
target = root.querySelector('[data-sfg-group="ram-ecm-unlock"] input:not(:disabled)');
}
else if (message.includes('transmission')) target = root.querySelector('[data-sfg-group="ram-trans"] input:not(:disabled)');
if (target) {
target.focus({ preventScroll: true });
target.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
}
async function decodeVin(vin, requestToken) {
if (requestToken !== state.requestToken) return;
if (state.controller) state.controller.abort();
state.controller = new AbortController();
const controller = state.controller;
let timedOut = false;
const timeoutId = window.setTimeout(() => {
timedOut = true;
controller.abort();
}, 6000);
state.decodeStatus = 'loading';
setStatus('Checking VIN…');
try {
const result = await fetchDecodedVin(vin, controller.signal);
if (requestToken !== state.requestToken || normalizeVin(vinInput.value) !== vin) return;
state.decodeStatus = 'success';
ensureConditionalFields();
applyDecodedResult(result, false);
const compatibilityError = evaluateCompatibility(result);
dispatchDecodedEvent(vin, result, 'vehicle-details', root);
if (compatibilityError) {
/* Keep the decoded Vehicle Details visible, but suppress configuration
   questions that belong to a vehicle which does not match this listing. */
clearConditionalFields();
setElementHidden(editButton, true);
vinInput.setCustomValidity(compatibilityError);
setStatus(compatibilityError, 'error');
} else {
vinInput.setCustomValidity('');
setStatus('VIN verified ✓');
}
} catch (error) {
if (requestToken !== state.requestToken || normalizeVin(vinInput.value) !== vin) return;
if (error?.name === 'AbortError' && !timedOut) return;
if (error?.sfgVinInvalid) {
state.decodeStatus = 'invalid';
clearConditionalFields();
hideDecoded();
vinInput.setCustomValidity(error.message);
setStatus(error.message, 'error');
return;
}
state.decodeStatus = 'fallback';
ensureConditionalFields();
applyApiFailureFallback(vin);
setStatus(
timedOut
? 'VIN lookup timed out. Please confirm the vehicle details below.'
: 'VIN is valid, but automatic vehicle lookup was unavailable. Please confirm the vehicle details below.'
);
console.warn('SFG VIN decoder:', error);
} finally {
window.clearTimeout(timeoutId);
if (state.controller === controller) state.controller = null;
}
}
function scheduleDecode() {
const vin = normalizeVin(vinInput.value);
vinInput.value = vin;
vinInput.setCustomValidity('');
if (state.timer) window.clearTimeout(state.timer);
if (state.controller) state.controller.abort();
state.requestToken += 1;
const requestToken = state.requestToken;
state.decodeStatus = vin.length ? 'incomplete' : 'empty';
state.result = null;
state.manufacturer = '';
state.hdApplication = false;
state.body = '';
state.truckSize = '';
state.rear = '';
state.rearLocked = false;
state.drive = '';
state.transmission = '';
state.manualOverride = false;
state.compatibilityMismatch = '';
resetPropertiesForNewVin();
dispatchVehicleDetailsUpdated();
clearConditionalFields();
hideDecoded();
if (vin.length < 17) {
setStatus(vin.length ? `${vin.length}/17 characters` : '');
return;
}
if (!isVinChecksumValid(vin)) {
state.decodeStatus = 'invalid';
vinInput.setCustomValidity('VIN check digit does not match. Please check the VIN.');
setStatus('VIN check digit does not match. Please check the VIN.', 'error');
return;
}
if (!isVinModelYearCodeValid(vin)) {
state.decodeStatus = 'invalid';
vinInput.setCustomValidity('VIN position 10 is not a valid model-year code. Please check the VIN.');
setStatus('VIN position 10 is not a valid model-year code. Please check the VIN.', 'error');
return;
}
state.decodeStatus = 'loading';
setStatus('Checking VIN…');
state.timer = window.setTimeout(() => decodeVin(vin, requestToken), 250);
}
vinInput.addEventListener('input', (event) => {
if (event.isTrusted && getSavedVin()) clearSavedVin();
scheduleDecode();
});
vinInput.addEventListener('paste', () => window.setTimeout(scheduleDecode, 0));
tireInput.addEventListener('input', () => {
const value = text(tireInput.value);
setProperty('tire', value || 'Stock');
});
root.addEventListener('change', (event) => {
if (!event.target.matches('[data-sfg-choice]')) return;
syncSelectionsToProperties();
updateDependentGroups();
refreshCompatibilityStatus();
dispatchVehicleDetailsUpdated();
});
editButton.addEventListener('click', () => {
if (!state.result || state.compatibilityMismatch) return;
state.manualOverride = true;
applyDecodedResult(state.result, true);
setStatus('VIN verified ✓ — vehicle details are open for manual confirmation.');
});
function interceptInvalidConfiguration(event) {
const button = event.target.closest?.('button[type="submit"][name="add"], input[type="submit"][name="add"]');
if (!button || button.form?.id !== formId) return;
syncSelectionsToProperties();
updateDependentGroups();
refreshCompatibilityStatus();
const missing = firstMissingRequirement();
if (!missing) return;
event.preventDefault();
event.stopImmediatePropagation();
setStatus(missing, 'error');
focusMissingRequirement(missing);
}
document.addEventListener('click', interceptInvalidConfiguration, true);
if (form) {
form.addEventListener('submit', (event) => {
syncSelectionsToProperties();
updateDependentGroups();
refreshCompatibilityStatus();
const missing = firstMissingRequirement();
if (!missing) return;
event.preventDefault();
event.stopImmediatePropagation();
setStatus(missing, 'error');
focusMissingRequirement(missing);
}, true);
}
clearConditionalFields();
setProperty('tire', 'Stock');
if (!normalizeVin(vinInput.value)) {
const savedVin = getSavedVin();
if (savedVin) vinInput.value = savedVin;
}
root.dataset.sfgVehicleInitialized = '1';
if (vinInput.value) scheduleDecode();
}
function showStartupError(root, error) {
const status = root?.querySelector?.('[data-sfg-vin-status]');
const message = error?.message || String(error || 'Unknown decoder error');
if (status) {
status.textContent = `Vehicle decoder error: ${message}`;
status.dataset.state = 'error';
}
console.error('SFG Vehicle Decoder startup error:', error, root);
}
function initAllVehicleDetails(scope = document) {
scope.querySelectorAll('[data-sfg-vehicle-details]').forEach((root) => {
try {
initVehicleDetails(root);
} catch (error) {
delete root.dataset.sfgVehicleInitialized;
showStartupError(root, error);
}
});
}

/* Register the public API BEFORE attempting page initialization.
   This prevents one bad block from making the asset appear not to load. */
window.SFGVehicleDecoder = {
initAllVehicleDetails,
normalizeVin,
validateVin,
decodeVinValue,
getDecodedDisplay,
getSavedVin,
saveVin,
clearSavedVin,
getCurrentVehicle,
setCurrentVehicle,
clearCurrentVehicle,
buildCurrentVehicle,
dispatchDecodedEvent,
isSotfProductTitle,
isFordMediumDuty,
getSotfAvailability,
isHdConfigurationApplication,
detectNonHdDrive,
detectGenericListingTarget,
evaluateGenericListingCompatibility,
isHdConfigurationListingTitle
};

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initAllVehicleDetails());
} else {
initAllVehicleDetails();
}
document.addEventListener('shopify:section:load', (event) => {
initAllVehicleDetails(event.target);
});
})();
